export default __webpack_public_path__ + "static/media/krilne1.b9225e39.png";